export const trackEvent = (data: unknown) => {
  if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }
  window.dataLayer.push(data);
};

export const trackEvents = (events: unknown[]) => events.forEach(trackEvent);
